import React from 'react'
import Break from '../DMGComponents/Break'
import { acceptPrivacyPolicy, loadPrivacyPolicy } from '../fetchData';
import toast, { Toaster } from 'react-hot-toast';
import Button from '../DMGComponents/Button';

class PrivacyPolicy extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            privacyPolicy: "",
            policyLoaded: false,
        }
    }

    componentDidMount() {
        loadPrivacyPolicy().then((res) => {
            this.setState({
                privacyPolicy: res,
                policyLoaded: true
            });
        }).catch((err) => {
            console.log(err);
            toast.error("Error loading privacy policy");
        });
    }

    agree = () => {
        if (this.props.noDbWriteNeeded) {
            this.props.agreeToPrivacyPolicy();
            return;
        }
        acceptPrivacyPolicy(this.props.area.id, this.props.area.permissionId).then(() => {
            this.props.agreeToPrivacyPolicy();
        }).catch((err) => {
            toast.error(err);
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }}>
                <Toaster />
                <Break style={{ margin: "16px 0 12px 0" }}>
                    Privacy Policy
                </Break>
                <div className={ "bgGradient" }>
                    <p dangerouslySetInnerHTML={{ __html: this.state.privacyPolicy}}></p>
                </div>
                {this.state.policyLoaded &&
                    <div style={{ display: "flex", justifyContent: "right", marginBottom: "12px", marginTop: '8px' }}>
                        <div>
                            <Button type="hover-bottom-left" onClick={this.agree}>Agree</Button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default PrivacyPolicy;